export type Predictions = {
  version: '0.1.0';
  name: 'predictions';
  instructions: [
    {
      name: 'initialize';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: [
            'The signer who initializes the program becomes the authority',
          ];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: true;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'vault';
          isMut: true;
          isSigner: false;
          docs: ['Program vault PDA that signs for token transfers'];
        },
        {
          name: 'adminState';
          isMut: true;
          isSigner: false;
          docs: ['The admin state account'];
        },
        {
          name: 'feeTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ['The token account for collecting fees, owned by the vault'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'args';
          type: {
            defined: 'InitArgs';
          };
        },
      ];
    },
    {
      name: 'createPrediction';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be either the authority or oracle'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ["The token account that will hold the market's collateral"];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The new prediction market account to be created'];
        },
        {
          name: 'adminState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: [
            'The orderbook account that will store all orders for this market',
          ];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'args';
          type: {
            defined: 'CreatePredictionArgs';
          };
        },
      ];
    },
    {
      name: 'closeOrderbook';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be either the authority or oracle'];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          isOptional: true;
          docs: ['The orderbook account that will be closed'];
        },
        {
          name: 'orderbook5000';
          isMut: true;
          isSigner: false;
          isOptional: true;
        },
        {
          name: 'orderbook200';
          isMut: true;
          isSigner: false;
          isOptional: true;
        },
        {
          name: 'orderbook20000';
          isMut: true;
          isSigner: false;
          isOptional: true;
        },
        {
          name: 'authority';
          isMut: true;
          isSigner: false;
          docs: [
            'The account that will receive the lamports from the closed orderbook',
          ];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
      ];
    },
    {
      name: 'submitReferral';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The user submitting the referral code'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: ["The user's state account, initialized if it doesn't exist"];
        },
        {
          name: 'referrerState';
          isMut: true;
          isSigner: false;
          docs: ["The referrer's user state account"];
        },
        {
          name: 'referralState';
          isMut: true;
          isSigner: false;
          docs: ['The referral state account containing the code to verify'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'code';
          type: 'string';
        },
      ];
    },
    {
      name: 'placeLimitOrder200';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be the owner of the token account'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'authority';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: [
            'The prediction market account where the order is being placed',
          ];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing all orders for this market'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'oracle';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's position state for tracking shares in this market",
          ];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's state account for tracking overall platform activity",
          ];
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The user's token account that will be used for transfers"];
        },
        {
          name: 'userStateTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ['The token account owned by the user_state PDA'];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderOutcome';
          type: 'u8';
        },
        {
          name: 'price';
          type: 'u8';
        },
        {
          name: 'size';
          type: 'u32';
        },
        {
          name: 'prevNodeId';
          type: 'u16';
        },
        {
          name: 'expiredAt';
          type: {
            option: 'u32';
          };
        },
        {
          name: 'isMarketLimit';
          type: 'bool';
        },
        {
          name: 'isMerge';
          type: 'bool';
        },
      ];
    },
    {
      name: 'placeLimitOrder';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be the owner of the token account'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'authority';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: [
            'The prediction market account where the order is being placed',
          ];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing all orders for this market'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'oracle';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's position state for tracking shares in this market",
          ];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's state account for tracking overall platform activity",
          ];
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The user's token account that will be used for transfers"];
        },
        {
          name: 'userStateTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ['The token account owned by the user_state PDA'];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderOutcome';
          type: 'u8';
        },
        {
          name: 'price';
          type: 'u8';
        },
        {
          name: 'size';
          type: 'u32';
        },
        {
          name: 'prevNodeId';
          type: 'u16';
        },
        {
          name: 'expiredAt';
          type: {
            option: 'u32';
          };
        },
        {
          name: 'isMarketLimit';
          type: 'bool';
        },
        {
          name: 'isMerge';
          type: 'bool';
        },
      ];
    },
    {
      name: 'placeLimitOrder5000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be the owner of the token account'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'authority';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: [
            'The prediction market account where the order is being placed',
          ];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing all orders for this market'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'oracle';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's position state for tracking shares in this market",
          ];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's state account for tracking overall platform activity",
          ];
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The user's token account that will be used for transfers"];
        },
        {
          name: 'userStateTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ['The token account owned by the user_state PDA'];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderOutcome';
          type: 'u8';
        },
        {
          name: 'price';
          type: 'u8';
        },
        {
          name: 'size';
          type: 'u32';
        },
        {
          name: 'prevNodeId';
          type: 'u16';
        },
        {
          name: 'expiredAt';
          type: {
            option: 'u32';
          };
        },
        {
          name: 'isMarketLimit';
          type: 'bool';
        },
        {
          name: 'isMerge';
          type: 'bool';
        },
      ];
    },
    {
      name: 'placeLimitOrder20000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be the owner of the token account'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'authority';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: [
            'The prediction market account where the order is being placed',
          ];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing all orders for this market'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'oracle';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's position state for tracking shares in this market",
          ];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's state account for tracking overall platform activity",
          ];
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The user's token account that will be used for transfers"];
        },
        {
          name: 'userStateTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ['The token account owned by the user_state PDA'];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderOutcome';
          type: 'u8';
        },
        {
          name: 'price';
          type: 'u8';
        },
        {
          name: 'size';
          type: 'u32';
        },
        {
          name: 'prevNodeId';
          type: 'u16';
        },
        {
          name: 'expiredAt';
          type: {
            option: 'u32';
          };
        },
        {
          name: 'isMarketLimit';
          type: 'bool';
        },
        {
          name: 'isMerge';
          type: 'bool';
        },
      ];
    },
    {
      name: 'placeMarketOrder';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
        },
        {
          name: 'oracle';
          isMut: true;
          isSigner: false;
          docs: ['CHECKED: ORACLE'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userStateTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'referralState';
          isMut: true;
          isSigner: false;
          isOptional: true;
        },
        {
          name: 'feeTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderOutcome';
          type: 'u8';
        },
        {
          name: 'size';
          type: 'u32';
        },
        {
          name: 'limitIdsToFill';
          type: {
            vec: 'u16';
          };
        },
        {
          name: 'isMarketLimit';
          type: 'bool';
        },
      ];
    },
    {
      name: 'placeMarketOrder200';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
        },
        {
          name: 'oracle';
          isMut: true;
          isSigner: false;
          docs: ['CHECKED: ORACLE'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userStateTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'referralState';
          isMut: true;
          isSigner: false;
          isOptional: true;
        },
        {
          name: 'feeTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderOutcome';
          type: 'u8';
        },
        {
          name: 'size';
          type: 'u32';
        },
        {
          name: 'limitIdsToFill';
          type: {
            vec: 'u16';
          };
        },
        {
          name: 'isMarketLimit';
          type: 'bool';
        },
      ];
    },
    {
      name: 'placeMarketOrder5000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
        },
        {
          name: 'oracle';
          isMut: true;
          isSigner: false;
          docs: ['CHECKED: ORACLE'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userStateTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'referralState';
          isMut: true;
          isSigner: false;
          isOptional: true;
        },
        {
          name: 'feeTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderOutcome';
          type: 'u8';
        },
        {
          name: 'size';
          type: 'u32';
        },
        {
          name: 'limitIdsToFill';
          type: {
            vec: 'u16';
          };
        },
        {
          name: 'isMarketLimit';
          type: 'bool';
        },
      ];
    },
    {
      name: 'placeMarketOrder20000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
        },
        {
          name: 'oracle';
          isMut: true;
          isSigner: false;
          docs: ['CHECKED: ORACLE'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'userStateTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'referralState';
          isMut: true;
          isSigner: false;
          isOptional: true;
        },
        {
          name: 'feeTokenAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderOutcome';
          type: 'u8';
        },
        {
          name: 'size';
          type: 'u32';
        },
        {
          name: 'limitIdsToFill';
          type: {
            vec: 'u16';
          };
        },
        {
          name: 'isMarketLimit';
          type: 'bool';
        },
      ];
    },
    {
      name: 'settleOrders';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer initiating the settlement'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing all orders for this market'];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account for the orders being settled'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ['The vault that holds collateral for the market'];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'vault';
          isMut: true;
          isSigner: false;
          docs: [
            'The fee vault account that collects trading fees',
            'CHECKED: VAULT',
          ];
        },
        {
          name: 'feeTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ['The token account for collecting fees'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program for SOL transfers and account creation'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'idsToSettle';
          type: {
            vec: 'u16';
          };
        },
        {
          name: 'accountsScheme';
          type: {
            vec: {
              vec: 'u16';
            };
          };
        },
      ];
    },
    {
      name: 'settleOrders200';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer initiating the settlement'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing all orders for this market'];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account for the orders being settled'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ['The vault that holds collateral for the market'];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'vault';
          isMut: true;
          isSigner: false;
          docs: [
            'The fee vault account that collects trading fees',
            'CHECKED: VAULT',
          ];
        },
        {
          name: 'feeTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ['The token account for collecting fees'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program for SOL transfers and account creation'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'idsToSettle';
          type: {
            vec: 'u16';
          };
        },
        {
          name: 'accountsScheme';
          type: {
            vec: {
              vec: 'u16';
            };
          };
        },
      ];
    },
    {
      name: 'settleOrders5000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer initiating the settlement'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing all orders for this market'];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account for the orders being settled'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ['The vault that holds collateral for the market'];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'vault';
          isMut: true;
          isSigner: false;
          docs: [
            'The fee vault account that collects trading fees',
            'CHECKED: VAULT',
          ];
        },
        {
          name: 'feeTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ['The token account for collecting fees'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program for SOL transfers and account creation'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'idsToSettle';
          type: {
            vec: 'u16';
          };
        },
        {
          name: 'accountsScheme';
          type: {
            vec: {
              vec: 'u16';
            };
          };
        },
      ];
    },
    {
      name: 'settleOrders20000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer initiating the settlement'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing all orders for this market'];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account for the orders being settled'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ['The vault that holds collateral for the market'];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'vault';
          isMut: true;
          isSigner: false;
          docs: [
            'The fee vault account that collects trading fees',
            'CHECKED: VAULT',
          ];
        },
        {
          name: 'feeTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ['The token account for collecting fees'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program for SOL transfers and account creation'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'idsToSettle';
          type: {
            vec: 'u16';
          };
        },
        {
          name: 'accountsScheme';
          type: {
            vec: {
              vec: 'u16';
            };
          };
        },
      ];
    },
    {
      name: 'cancelLimitOrder';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be the owner of the order'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing the order to be canceled'];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account containing the order'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ["The token account holding the market's collateral"];
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The user's token account to receive refunded collateral"];
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
          docs: ["The user's position account for this market"];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: ["The user's global state account"];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderId';
          type: 'u16';
        },
      ];
    },
    {
      name: 'cancelLimitOrder200';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be the owner of the order'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing the order to be canceled'];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account containing the order'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ["The token account holding the market's collateral"];
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The user's token account to receive refunded collateral"];
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
          docs: ["The user's position account for this market"];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: ["The user's global state account"];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderId';
          type: 'u16';
        },
      ];
    },
    {
      name: 'cancelLimitOrder5000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be the owner of the order'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing the order to be canceled'];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account containing the order'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ["The token account holding the market's collateral"];
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The user's token account to receive refunded collateral"];
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
          docs: ["The user's position account for this market"];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: ["The user's global state account"];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderId';
          type: 'u16';
        },
      ];
    },
    {
      name: 'cancelLimitOrder20000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be the owner of the order'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'orderbook';
          isMut: true;
          isSigner: false;
          docs: ['The orderbook containing the order to be canceled'];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account containing the order'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ["The token account holding the market's collateral"];
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The user's token account to receive refunded collateral"];
        },
        {
          name: 'userPositionState';
          isMut: true;
          isSigner: false;
          docs: ["The user's position account for this market"];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: ["The user's global state account"];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'orderType';
          type: 'u8';
        },
        {
          name: 'orderId';
          type: 'u16';
        },
      ];
    },
    {
      name: 'createReferral';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer creating the referral code'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: ["The user's state account, initialized if it doesn't exist"];
        },
        {
          name: 'referrerState';
          isMut: true;
          isSigner: false;
          docs: ['The new referral state account to be created'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'code';
          type: 'string';
        },
      ];
    },
    {
      name: 'claimFee';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The authority that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: [
            "Global state account storing the program's configuration and fee tracking",
          ];
        },
        {
          name: 'signerTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The authority's token account to receive the claimed fees"];
        },
        {
          name: 'vault';
          isMut: true;
          isSigner: false;
          docs: ['Program vault PDA that signs for token transfers'];
        },
        {
          name: 'feeVault';
          isMut: true;
          isSigner: false;
          docs: [
            'The fee vault token account that holds accumulated protocol fees',
          ];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [];
    },
    {
      name: 'changeConfig';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The current authority that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'args';
          type: {
            defined: 'ChangeConfigArgs';
          };
        },
      ];
    },
    {
      name: 'settleResult';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The oracle that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'predictionMarket';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account to be settled'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'result';
          type: 'u8';
        },
        {
          name: 'settlementTimestamp';
          type: 'u64';
        },
      ];
    },
    {
      name: 'claimReferralFee';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be the owner of the UserState'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'signerTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The user's token account that will receive the claimed fees"];
        },
        {
          name: 'vault';
          isMut: true;
          isSigner: false;
          docs: ['Program vault PDA that signs for token transfers'];
        },
        {
          name: 'feeVault';
          isMut: true;
          isSigner: false;
          docs: ['The fee vault token account that holds collected fees'];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's state account that tracks referral fees earned and claimed",
          ];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [];
    },
    {
      name: 'changeMarketStatus';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be either the oracle or the authority'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'predictionMarket';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account to be modified'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'status';
          type: 'u8';
        },
      ];
    },
    {
      name: 'settleWinningFunds';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The oracle that must sign the transaction'];
        },
        {
          name: 'authorityTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ["The oracle's token account to receive settlement fees"];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account whose winners will be paid'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ["The token account holding the market's collateral"];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'vault';
          isMut: true;
          isSigner: false;
          docs: [
            'Program vault PDA that signs for token transfers',
            'CHECKED: VAULT',
          ];
        },
        {
          name: 'feeTokenAccount';
          isMut: true;
          isSigner: false;
          docs: ['The fee vault token account that holds collected fees'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
      ];
    },
    {
      name: 'claimLimitFunds';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be the owner of the UserState'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'userState';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's state account that holds ownership of the token account",
          ];
        },
        {
          name: 'userStateTokenAccount';
          isMut: true;
          isSigner: false;
          docs: [
            'The token account owned by the user_state PDA which holds the funds',
          ];
        },
        {
          name: 'userTokenAccount';
          isMut: true;
          isSigner: false;
          docs: [
            "The user's personal token account that will receive the funds",
          ];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [];
    },
    {
      name: 'editMarket';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The signer must be either the oracle or the authority'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'adminState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionMarket';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account to be modified'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
        {
          name: 'args';
          type: {
            defined: 'EditMarketArgs';
          };
        },
      ];
    },
    {
      name: 'changeAuthority';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The current authority that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'authority';
          type: 'publicKey';
        },
      ];
    },
    {
      name: 'collectRemainingFunds';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The oracle that must sign the transaction'];
        },
        {
          name: 'authority';
          isMut: true;
          isSigner: false;
          docs: ['The authority account that will receive the funds'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'predictionMarket';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account whose funds will be collected'];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ["The token account holding the market's collateral"];
        },
        {
          name: 'authorityTokenAccount';
          isMut: true;
          isSigner: false;
          docs: [
            "The authority's token account to receive the recovered funds",
          ];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
      ];
    },
    {
      name: 'refund';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The oracle that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: ['The prediction market account whose funds will be refunded'];
        },
        {
          name: 'predictionVault';
          isMut: true;
          isSigner: false;
          docs: ["The token account holding the market's collateral"];
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
          docs: ['The mint of the token being transferred'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Token program interface for token transfers'];
        },
        {
          name: 'associatedTokenProgram';
          isMut: false;
          isSigner: false;
          docs: ['Associated token program for token account validation'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
      ];
    },
    {
      name: 'migrateOrderbook5000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The admin that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'adminState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: [
            'The prediction market account to update with the new orderbook',
          ];
        },
        {
          name: 'sourceOrderbook';
          isMut: true;
          isSigner: false;
          docs: ['The source orderbook account (1000 order capacity)'];
        },
        {
          name: 'targetOrderbook';
          isMut: true;
          isSigner: false;
          docs: [
            'The target orderbook account (2000 order capacity)',
            'This account should be initialized but empty',
          ];
        },
        {
          name: 'authority';
          isMut: true;
          isSigner: false;
          docs: [
            'The authority that will receive the lamports from the closed source orderbook',
          ];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
      ];
    },
    {
      name: 'migrateOrderbook20000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The admin that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'adminState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: [
            'The prediction market account to update with the new orderbook',
          ];
        },
        {
          name: 'sourceOrderbook';
          isMut: true;
          isSigner: false;
          isOptional: true;
          docs: ['The source orderbook account (1000 order capacity)'];
        },
        {
          name: 'sourceOrderbook5000';
          isMut: true;
          isSigner: false;
          isOptional: true;
          docs: ['The source orderbook account (3000 order capacity)'];
        },
        {
          name: 'targetOrderbook';
          isMut: true;
          isSigner: false;
          docs: ['The target orderbook account (8000 order capacity)'];
        },
        {
          name: 'authority';
          isMut: true;
          isSigner: false;
          docs: [
            'The authority that will receive the lamports from the closed source orderbook',
          ];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
      ];
    },
    {
      name: 'migrateOrderbook1000';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The admin that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'adminState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: [
            'The prediction market account to update with the new orderbook',
          ];
        },
        {
          name: 'sourceOrderbook';
          isMut: true;
          isSigner: false;
          docs: ['The source orderbook account (500 orders per side)'];
        },
        {
          name: 'targetOrderbook';
          isMut: true;
          isSigner: false;
          docs: [
            'The target orderbook account (100 orders per side)',
            'This account should be initialized but empty',
          ];
        },
        {
          name: 'authority';
          isMut: true;
          isSigner: false;
          docs: [
            'The authority that will receive the lamports from the closed source orderbook',
          ];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
      ];
    },
    {
      name: 'migrateOrderbook200';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The admin that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'adminState';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'predictionState';
          isMut: true;
          isSigner: false;
          docs: [
            'The prediction market account to update with the new orderbook',
          ];
        },
        {
          name: 'sourceOrderbook';
          isMut: true;
          isSigner: false;
          docs: ['The source orderbook account (1000 order capacity)'];
        },
        {
          name: 'targetOrderbook';
          isMut: true;
          isSigner: false;
          docs: [
            'The target orderbook account (2000 order capacity)',
            'This account should be initialized but empty',
          ];
        },
        {
          name: 'authority';
          isMut: true;
          isSigner: false;
          docs: [
            'The authority that will receive the lamports from the closed source orderbook',
          ];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'marketId';
          type: 'u64';
        },
      ];
    },
    {
      name: 'changeAdmin';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The current authority that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'adminState';
          isMut: true;
          isSigner: false;
          docs: ['The admin state account'];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'index';
          type: 'u8';
        },
        {
          name: 'admin';
          type: 'publicKey';
        },
        {
          name: 'isAdmin';
          type: 'bool';
        },
      ];
    },
    {
      name: 'changeWhitelist';
      accounts: [
        {
          name: 'signer';
          isMut: true;
          isSigner: true;
          docs: ['The current authority that must sign the transaction'];
        },
        {
          name: 'globalState';
          isMut: true;
          isSigner: false;
          docs: ["Global state account storing the program's configuration"];
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
          docs: ['System program'];
        },
      ];
      args: [
        {
          name: 'isWhitelisted';
          type: 'u32';
        },
      ];
    },
  ];
  accounts: [
    {
      name: 'adminState';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'admins';
            type: {
              array: ['publicKey', 10];
            };
          },
        ];
      };
    },
    {
      name: 'globalState';
      docs: [
        'GlobalState manages program-wide configuration parameters',
        '',
        'This is the central account that stores program settings, fee structures,',
        'and tracks global counters. There is only one instance of this account',
        'per program deployment.',
        '',
        '# Security',
        '- Only the authority can update configuration parameters',
        '- Maintains counters for unique ID generation',
        '- Stores critical fee settings that impact user economics',
      ];
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'authority';
            docs: ['The authority who can update program parameters'];
            type: 'publicKey';
          },
          {
            name: 'oracle';
            docs: ['Oracle address that provides market resolution'];
            type: 'publicKey';
          },
          {
            name: 'feeVault';
            type: 'publicKey';
          },
          {
            name: 'referralFeeCap';
            docs: ['Maximum referral fee allowed (lamports)'];
            type: 'u64';
          },
          {
            name: 'tradeFeePercent';
            docs: ['Fee percentage for trades (basis points)'];
            type: 'u16';
          },
          {
            name: 'settleFeePercent';
            docs: ['Fee percentage for settlements (basis points)'];
            type: 'u16';
          },
          {
            name: 'referralFeePercent';
            docs: ['Fee percentage for referrals (basis points)'];
            type: 'u16';
          },
          {
            name: 'referralFeeDiscount';
            docs: ['Discount for referral fees (basis points)'];
            type: 'u16';
          },
          {
            name: 'claimableAdminFee';
            docs: ['Claimable admin fee (lamports)'];
            type: 'u64';
          },
          {
            name: 'limitOrderFeeSol';
            docs: ['Limit order fee in SOL (lamports)'];
            type: 'u32';
          },
          {
            name: 'settlementFeeSol';
            docs: ['Settlement fee in SOL (lamports)'];
            type: 'u32';
          },
          {
            name: 'predictionId';
            docs: ['ID that will be created next'];
            type: 'u64';
          },
          {
            name: 'collateralMint';
            docs: ['Collateral token mint'];
            type: 'publicKey';
          },
          {
            name: 'liquidityIncentiveMaxSpread';
            docs: ['Liquidity incentive max spread (bps), 1 cent - 1'];
            type: 'u8';
          },
          {
            name: 'liquidityIncentiveDiscountPerSpread';
            docs: [
              'Liquidity incentive discount percent, 100 = 1%',
              'Example: default fee = 100 (1%), liquidity incentive discount = 10 (0.1%), max_spread = 1, spread = 1',
              'effective fee = 90 (0.9%)',
              'Example: default fee = 100 (1%), liquidity incentive discount = 10 (0.1%), max_spread = 3, spread = 1,',
              'effective fee = 70 (0.7%)',
              'Example: default fee = 100 (1%), liquidity incentive discount = 10 (0.1%), max_spread = 3, spread = 4',
              'effective fee = 100 (1%)',
              'Example: default fee = 100 (1%), liquidity incentive discount = 10 (0.1%), max_spread = 3, spread = 3',
              'effective fee = 90 (0.9%)',
            ];
            type: 'u8';
          },
          {
            name: 'expirationThreshold';
            docs: ['Expiration threshold for orders (seconds)'];
            type: 'u16';
          },
          {
            name: 'nextOrderId';
            docs: ['Next order ID'];
            type: 'u32';
          },
        ];
      };
    },
    {
      name: 'orderBook20000';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'bids';
            type: {
              array: [
                {
                  defined: 'Order';
                },
                10000,
              ];
            };
          },
          {
            name: 'asks';
            type: {
              array: [
                {
                  defined: 'Order';
                },
                10000,
              ];
            };
          },
          {
            name: 'bidHead';
            type: 'u16';
          },
          {
            name: 'askHead';
            type: 'u16';
          },
          {
            name: 'bidFreeListHead';
            type: 'u16';
          },
          {
            name: 'askFreeListHead';
            type: 'u16';
          },
          {
            name: 'globalState';
            type: 'publicKey';
          },
        ];
      };
    },
    {
      name: 'orderBook200';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'bids';
            type: {
              array: [
                {
                  defined: 'Order';
                },
                100,
              ];
            };
          },
          {
            name: 'asks';
            type: {
              array: [
                {
                  defined: 'Order';
                },
                100,
              ];
            };
          },
          {
            name: 'bidHead';
            type: 'u16';
          },
          {
            name: 'askHead';
            type: 'u16';
          },
          {
            name: 'bidFreeListHead';
            type: 'u16';
          },
          {
            name: 'askFreeListHead';
            type: 'u16';
          },
          {
            name: 'globalState';
            type: 'publicKey';
          },
        ];
      };
    },
    {
      name: 'orderBook5000';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'bids';
            type: {
              array: [
                {
                  defined: 'Order';
                },
                2500,
              ];
            };
          },
          {
            name: 'asks';
            type: {
              array: [
                {
                  defined: 'Order';
                },
                2500,
              ];
            };
          },
          {
            name: 'bidHead';
            type: 'u16';
          },
          {
            name: 'askHead';
            type: 'u16';
          },
          {
            name: 'bidFreeListHead';
            type: 'u16';
          },
          {
            name: 'askFreeListHead';
            type: 'u16';
          },
          {
            name: 'globalState';
            type: 'publicKey';
          },
        ];
      };
    },
    {
      name: 'orderBook';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'bids';
            type: {
              array: [
                {
                  defined: 'Order';
                },
                500,
              ];
            };
          },
          {
            name: 'asks';
            type: {
              array: [
                {
                  defined: 'Order';
                },
                500,
              ];
            };
          },
          {
            name: 'bidHead';
            type: 'u16';
          },
          {
            name: 'askHead';
            type: 'u16';
          },
          {
            name: 'bidFreeListHead';
            type: 'u16';
          },
          {
            name: 'askFreeListHead';
            type: 'u16';
          },
          {
            name: 'globalState';
            type: 'publicKey';
          },
        ];
      };
    },
    {
      name: 'predictionMarketState';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'token';
            type: 'publicKey';
          },
          {
            name: 'orderbook';
            type: 'publicKey';
          },
          {
            name: 'orderbookSize';
            type: 'u16';
          },
          {
            name: 'predictionVault';
            type: 'publicKey';
          },
          {
            name: 'startTime';
            type: 'u64';
          },
          {
            name: 'endTime';
            type: 'u64';
          },
          {
            name: 'targetPrice';
            type: 'u64';
          },
          {
            name: 'predictionType';
            type: 'u16';
          },
          {
            name: 'targetPriceDirection';
            type: 'u8';
          },
          {
            name: 'result';
            type: 'u8';
          },
          {
            name: 'minSize';
            type: 'u64';
          },
          {
            name: 'status';
            type: 'u8';
          },
          {
            name: 'settlementTimestamp';
            type: 'u64';
          },
          {
            name: 'tradeFeePercent';
            type: 'u16';
          },
          {
            name: 'settleFeePercent';
            type: 'u16';
          },
        ];
      };
    },
    {
      name: 'referralState';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'user';
            type: 'publicKey';
          },
          {
            name: 'code';
            type: 'string';
          },
        ];
      };
    },
    {
      name: 'userPositionState';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'user';
            type: 'publicKey';
          },
          {
            name: 'marketId';
            type: 'u64';
          },
          {
            name: 'yesShares';
            type: 'u64';
          },
          {
            name: 'noShares';
            type: 'u64';
          },
          {
            name: 'feePayed';
            type: 'bool';
          },
          {
            name: 'totalSpent';
            type: 'u64';
          },
        ];
      };
    },
    {
      name: 'userState';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'user';
            type: 'publicKey';
          },
          {
            name: 'referrer';
            type: {
              option: 'publicKey';
            };
          },
          {
            name: 'code';
            type: {
              option: 'string';
            };
          },
          {
            name: 'totalReferrals';
            type: 'u32';
          },
          {
            name: 'isWhitelisted';
            type: 'u32';
          },
          {
            name: 'totalFeeEarned';
            type: 'u64';
          },
          {
            name: 'totalFeeClaimed';
            type: 'u64';
          },
        ];
      };
    },
  ];
  types: [
    {
      name: 'ComboBetCondition';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'token';
            type: {
              option: 'publicKey';
            };
          },
          {
            name: 'wallet';
            type: {
              option: 'publicKey';
            };
          },
          {
            name: 'predictionType';
            type: 'u16';
          },
          {
            name: 'targetPrice';
            type: 'u64';
          },
          {
            name: 'targetPriceDirection';
            type: 'u8';
          },
        ];
      };
    },
    {
      name: 'InitArgs';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'oracle';
            type: 'publicKey';
          },
          {
            name: 'tradeFeePercent';
            type: 'u16';
          },
          {
            name: 'settleFeePercent';
            type: 'u16';
          },
          {
            name: 'referralFeePercent';
            type: 'u16';
          },
          {
            name: 'referralFeeCap';
            type: 'u64';
          },
          {
            name: 'collateralMint';
            type: 'publicKey';
          },
        ];
      };
    },
    {
      name: 'CreatePredictionArgs';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'token';
            type: {
              option: 'publicKey';
            };
          },
          {
            name: 'wallet';
            type: {
              option: 'publicKey';
            };
          },
          {
            name: 'startTime';
            type: 'u64';
          },
          {
            name: 'endTime';
            type: 'u64';
          },
          {
            name: 'targetPrice';
            type: 'u64';
          },
          {
            name: 'targetPriceDirection';
            type: 'u8';
          },
          {
            name: 'minSize';
            type: 'u64';
          },
          {
            name: 'predictionType';
            type: 'u16';
          },
          {
            name: 'comboConditions';
            type: {
              vec: {
                defined: 'ComboBetCondition';
              };
            };
          },
        ];
      };
    },
    {
      name: 'ChangeConfigArgs';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'oracle';
            type: 'publicKey';
          },
          {
            name: 'tradeFeePercent';
            type: 'u16';
          },
          {
            name: 'settleFeePercent';
            type: 'u16';
          },
          {
            name: 'referralFeePercent';
            type: 'u16';
          },
          {
            name: 'referralFeeDiscount';
            type: 'u16';
          },
          {
            name: 'referralFeeCap';
            type: 'u64';
          },
          {
            name: 'settlementFeeSol';
            type: 'u32';
          },
          {
            name: 'limitOrderFeeSol';
            type: 'u32';
          },
          {
            name: 'expirationThreshold';
            type: 'u16';
          },
          {
            name: 'liquidityIncentiveMaxSpread';
            type: 'u8';
          },
          {
            name: 'liquidityIncentiveDiscountPerSpread';
            type: 'u8';
          },
        ];
      };
    },
    {
      name: 'EditMarketArgs';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'token';
            type: 'publicKey';
          },
          {
            name: 'startTime';
            type: 'u64';
          },
          {
            name: 'endTime';
            type: 'u64';
          },
          {
            name: 'targetPrice';
            type: 'u64';
          },
          {
            name: 'targetPriceDirection';
            type: 'u8';
          },
          {
            name: 'minSize';
            type: 'u64';
          },
          {
            name: 'tradeFeePercent';
            type: 'u16';
          },
          {
            name: 'settleFeePercent';
            type: 'u16';
          },
        ];
      };
    },
    {
      name: 'Order';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'user';
            type: 'publicKey';
          },
          {
            name: 'id';
            type: 'u32';
          },
          {
            name: 'size';
            type: 'u32';
          },
          {
            name: 'next';
            type: 'u16';
          },
          {
            name: 'prev';
            type: 'u16';
          },
          {
            name: 'price';
            type: 'u8';
          },
          {
            name: 'isFilled';
            type: 'u8';
          },
          {
            name: 'outcome';
            type: 'u8';
          },
          {
            name: 'spread';
            type: 'u8';
          },
          {
            name: 'expiryTimestamp';
            type: 'u32';
          },
          {
            name: 'feePayed';
            type: 'u32';
          },
        ];
      };
    },
  ];
  events: [
    {
      name: 'PredictionMarketCreated';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'predictionId';
          type: 'u64';
          index: false;
        },
        {
          name: 'startTime';
          type: 'u64';
          index: false;
        },
        {
          name: 'endTime';
          type: 'u64';
          index: false;
        },
        {
          name: 'token';
          type: {
            option: 'publicKey';
          };
          index: false;
        },
        {
          name: 'wallet';
          type: {
            option: 'publicKey';
          };
          index: false;
        },
        {
          name: 'predictionType';
          type: 'u16';
          index: false;
        },
        {
          name: 'targetPrice';
          type: 'u64';
          index: false;
        },
        {
          name: 'targetPriceDirection';
          type: 'u8';
          index: false;
        },
        {
          name: 'comboConditions';
          type: {
            vec: {
              defined: 'ComboBetCondition';
            };
          };
          index: false;
        },
      ];
    },
    {
      name: 'OrderPlaced';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'marketId';
          type: 'u64';
          index: false;
        },
        {
          name: 'orderId';
          type: 'u32';
          index: false;
        },
        {
          name: 'user';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'orderSide';
          type: 'u8';
          index: false;
        },
        {
          name: 'orderOutcome';
          type: 'u8';
          index: false;
        },
        {
          name: 'price';
          type: 'u8';
          index: false;
        },
        {
          name: 'size';
          type: 'u32';
          index: false;
        },
        {
          name: 'timestamp';
          type: 'u64';
          index: false;
        },
        {
          name: 'expiryTimestamp';
          type: 'u64';
          index: false;
        },
      ];
    },
    {
      name: 'OrderFilled';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'marketId';
          type: 'u64';
          index: false;
        },
        {
          name: 'orderId';
          type: 'u32';
          index: false;
        },
        {
          name: 'user';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'orderSide';
          type: 'u8';
          index: false;
        },
        {
          name: 'orderType';
          type: 'u8';
          index: false;
        },
        {
          name: 'orderOutcome';
          type: 'u8';
          index: false;
        },
        {
          name: 'avrgPrice';
          type: 'u8';
          index: false;
        },
        {
          name: 'size';
          type: 'u32';
          index: false;
        },
        {
          name: 'timestamp';
          type: 'u64';
          index: false;
        },
        {
          name: 'adminFee';
          type: 'u64';
          index: false;
        },
        {
          name: 'referralFee';
          type: 'u64';
          index: false;
        },
      ];
    },
    {
      name: 'OrderCancelled';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'marketId';
          type: 'u64';
          index: false;
        },
        {
          name: 'orderId';
          type: 'u32';
          index: false;
        },
        {
          name: 'user';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'timestamp';
          type: 'u64';
          index: false;
        },
      ];
    },
    {
      name: 'ReferralCreated';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'user';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'code';
          type: 'string';
          index: false;
        },
      ];
    },
    {
      name: 'ReferralSubmitted';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'user';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'code';
          type: 'string';
          index: false;
        },
      ];
    },
    {
      name: 'ReferralFeeClaimed';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'user';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'amount';
          type: 'u64';
          index: false;
        },
        {
          name: 'referralCode';
          type: 'string';
          index: false;
        },
      ];
    },
    {
      name: 'PredictionSettled';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'marketId';
          type: 'u64';
          index: false;
        },
        {
          name: 'result';
          type: 'u8';
          index: false;
        },
        {
          name: 'settlementTimestamp';
          type: 'u64';
          index: false;
        },
      ];
    },
    {
      name: 'WinningFundsSettled';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'marketId';
          type: 'u64';
          index: false;
        },
        {
          name: 'user';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'winShares';
          type: 'u32';
          index: false;
        },
        {
          name: 'loseShares';
          type: 'u32';
          index: false;
        },
        {
          name: 'payout';
          type: 'u64';
          index: false;
        },
        {
          name: 'referralFee';
          type: 'u64';
          index: false;
        },
        {
          name: 'adminFee';
          type: 'u64';
          index: false;
        },
      ];
    },
    {
      name: 'RefundedFunds';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'marketId';
          type: 'u64';
          index: false;
        },
        {
          name: 'user';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'refundAmount';
          type: 'u64';
          index: false;
        },
      ];
    },
    {
      name: 'PredictionMarketStatusChanged';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'marketId';
          type: 'u64';
          index: false;
        },
        {
          name: 'status';
          type: 'u8';
          index: false;
        },
      ];
    },
    {
      name: 'PredictionMarketEdited';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'marketId';
          type: 'u64';
          index: false;
        },
        {
          name: 'token';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'startTime';
          type: 'u64';
          index: false;
        },
        {
          name: 'endTime';
          type: 'u64';
          index: false;
        },
        {
          name: 'targetPrice';
          type: 'u64';
          index: false;
        },
        {
          name: 'targetPriceDirection';
          type: 'u8';
          index: false;
        },
        {
          name: 'minSize';
          type: 'u64';
          index: false;
        },
        {
          name: 'tradeFeePercent';
          type: 'u16';
          index: false;
        },
        {
          name: 'settleFeePercent';
          type: 'u16';
          index: false;
        },
      ];
    },
    {
      name: 'TokensClaimed';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'user';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'amount';
          type: 'u64';
          index: false;
        },
        {
          name: 'timestamp';
          type: 'u64';
          index: false;
        },
      ];
    },
    {
      name: 'OrderbookClosed';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'marketId';
          type: 'u64';
          index: false;
        },
        {
          name: 'timestamp';
          type: 'u64';
          index: false;
        },
      ];
    },
    {
      name: 'RemainingFundsCollected';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'marketId';
          type: 'u64';
          index: false;
        },
        {
          name: 'timestamp';
          type: 'u64';
          index: false;
        },
      ];
    },
    {
      name: 'AdminChanged';
      fields: [
        {
          name: 'globalState';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'admin';
          type: 'publicKey';
          index: false;
        },
        {
          name: 'isAdmin';
          type: 'bool';
          index: false;
        },
      ];
    },
  ];
  errors: [
    {
      code: 6000;
      name: 'NotAuthority';
      msg: 'Not an authority!';
    },
    {
      code: 6001;
      name: 'InvalidProposalType';
      msg: 'Invalid proposal type!';
    },
    {
      code: 6002;
      name: 'InvalidTargetPriceDirection';
      msg: 'Invalid target price direction!';
    },
    {
      code: 6003;
      name: 'InvalidResult';
      msg: 'Invalid result!';
    },
    {
      code: 6004;
      name: 'InvalidStartTime';
      msg: 'Invalid start time!';
    },
    {
      code: 6005;
      name: 'InvalidCollateralMint';
      msg: 'Invalid collateral mint!';
    },
    {
      code: 6006;
      name: 'InvalidInput';
      msg: 'Invalid input parameters';
    },
    {
      code: 6007;
      name: 'OrderNotActive';
      msg: 'Order is not active';
    },
    {
      code: 6008;
      name: 'OrderNotFilled';
      msg: 'Order is not filled';
    },
    {
      code: 6009;
      name: 'InvalidFillSize';
      msg: 'Invalid fill size';
    },
    {
      code: 6010;
      name: 'SizeMismatch';
      msg: 'Size mismatch between bid and ask orders';
    },
    {
      code: 6011;
      name: 'InvalidOrderPosition';
      msg: 'Order position is invalid';
    },
    {
      code: 6012;
      name: 'OwnerMismatch';
      msg: 'Owner mismatch';
    },
    {
      code: 6013;
      name: 'InvalidSide';
      msg: 'Invalid side';
    },
    {
      code: 6014;
      name: 'InvalidPrice';
      msg: 'Invalid price';
    },
    {
      code: 6015;
      name: 'InvalidSize';
      msg: 'Invalid size';
    },
    {
      code: 6016;
      name: 'InsufficientShares';
      msg: 'Insufficient shares';
    },
    {
      code: 6017;
      name: 'InvalidLimitOrder';
      msg: 'Please use market order';
    },
    {
      code: 6018;
      name: 'NoOrdersToFill';
      msg: 'No orders to fill';
    },
    {
      code: 6019;
      name: 'InvalidOrderSequence';
      msg: 'Invalid order sequence';
    },
    {
      code: 6020;
      name: 'InvalidOrderId';
      msg: 'Invalid order ID';
    },
    {
      code: 6021;
      name: 'OrderAlreadyFilled';
      msg: 'Order already filled';
    },
    {
      code: 6022;
      name: 'InsufficientLiquidity';
      msg: 'Insufficient liquidity';
    },
    {
      code: 6023;
      name: 'OrderCannotBeSettled';
      msg: 'Order cannot be settled';
    },
    {
      code: 6024;
      name: 'MissingUserAccounts';
      msg: 'Missing user accounts';
    },
    {
      code: 6025;
      name: 'InvalidReferrer';
      msg: 'Invalid referrer';
    },
    {
      code: 6026;
      name: 'PredictionNotActive';
      msg: 'Prediction not active';
    },
    {
      code: 6027;
      name: 'CantChangeReferrer';
      msg: "You can't change your referrer";
    },
    {
      code: 6028;
      name: 'CantReferSelf';
      msg: "Can't refer yourself";
    },
    {
      code: 6029;
      name: 'ResultAlreadySettled';
      msg: 'Result already settled';
    },
    {
      code: 6030;
      name: 'NoClaimableFee';
      msg: 'No claimable fee';
    },
    {
      code: 6031;
      name: 'InvalidExpiration';
      msg: 'Invalid expiration';
    },
    {
      code: 6032;
      name: 'OrderExpired';
      msg: 'Order expired';
    },
    {
      code: 6033;
      name: 'MarketNotResolved';
      msg: 'Market not resolved';
    },
    {
      code: 6034;
      name: 'InvalidCode';
      msg: 'Invalid code';
    },
    {
      code: 6035;
      name: 'EmptyReferralCode';
      msg: 'Empty referral code';
    },
    {
      code: 6036;
      name: 'ReferralCodeTooLong';
      msg: 'Referral code too long';
    },
    {
      code: 6037;
      name: 'MarketLimitConstraintViolated';
      msg: 'Market limit constraint violated';
    },
    {
      code: 6038;
      name: 'MarketLimitPriceConflict';
      msg: 'Market limit price conflict';
    },
    {
      code: 6039;
      name: 'MarketNotClosed';
      msg: 'Market is not closed';
    },
    {
      code: 6040;
      name: 'MarketLimitOrderNotAllowed';
      msg: 'Market limit order is not allowed';
    },
    {
      code: 6041;
      name: 'InvalidOrderbookSize';
      msg: 'Invalid orderbook size';
    },
    {
      code: 6042;
      name: 'InvalidOrderbook';
      msg: 'Invalid orderbook';
    },
    {
      code: 6043;
      name: 'NotAdmin';
      msg: 'Not an admin';
    },
    {
      code: 6044;
      name: 'NoSpaceForAdmin';
      msg: 'No space for admin';
    },
  ];
};

export const IDL: Predictions = {
  version: '0.1.0',
  name: 'predictions',
  instructions: [
    {
      name: 'initialize',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: [
            'The signer who initializes the program becomes the authority',
          ],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: true,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'vault',
          isMut: true,
          isSigner: false,
          docs: ['Program vault PDA that signs for token transfers'],
        },
        {
          name: 'adminState',
          isMut: true,
          isSigner: false,
          docs: ['The admin state account'],
        },
        {
          name: 'feeTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ['The token account for collecting fees, owned by the vault'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'args',
          type: {
            defined: 'InitArgs',
          },
        },
      ],
    },
    {
      name: 'createPrediction',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be either the authority or oracle'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ["The token account that will hold the market's collateral"],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The new prediction market account to be created'],
        },
        {
          name: 'adminState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: [
            'The orderbook account that will store all orders for this market',
          ],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'args',
          type: {
            defined: 'CreatePredictionArgs',
          },
        },
      ],
    },
    {
      name: 'closeOrderbook',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be either the authority or oracle'],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          isOptional: true,
          docs: ['The orderbook account that will be closed'],
        },
        {
          name: 'orderbook5000',
          isMut: true,
          isSigner: false,
          isOptional: true,
        },
        {
          name: 'orderbook200',
          isMut: true,
          isSigner: false,
          isOptional: true,
        },
        {
          name: 'orderbook20000',
          isMut: true,
          isSigner: false,
          isOptional: true,
        },
        {
          name: 'authority',
          isMut: true,
          isSigner: false,
          docs: [
            'The account that will receive the lamports from the closed orderbook',
          ],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
      ],
    },
    {
      name: 'submitReferral',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The user submitting the referral code'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: ["The user's state account, initialized if it doesn't exist"],
        },
        {
          name: 'referrerState',
          isMut: true,
          isSigner: false,
          docs: ["The referrer's user state account"],
        },
        {
          name: 'referralState',
          isMut: true,
          isSigner: false,
          docs: ['The referral state account containing the code to verify'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'code',
          type: 'string',
        },
      ],
    },
    {
      name: 'placeLimitOrder200',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be the owner of the token account'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'authority',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: [
            'The prediction market account where the order is being placed',
          ],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing all orders for this market'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'oracle',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's position state for tracking shares in this market",
          ],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's state account for tracking overall platform activity",
          ],
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The user's token account that will be used for transfers"],
        },
        {
          name: 'userStateTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ['The token account owned by the user_state PDA'],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderOutcome',
          type: 'u8',
        },
        {
          name: 'price',
          type: 'u8',
        },
        {
          name: 'size',
          type: 'u32',
        },
        {
          name: 'prevNodeId',
          type: 'u16',
        },
        {
          name: 'expiredAt',
          type: {
            option: 'u32',
          },
        },
        {
          name: 'isMarketLimit',
          type: 'bool',
        },
        {
          name: 'isMerge',
          type: 'bool',
        },
      ],
    },
    {
      name: 'placeLimitOrder',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be the owner of the token account'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'authority',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: [
            'The prediction market account where the order is being placed',
          ],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing all orders for this market'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'oracle',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's position state for tracking shares in this market",
          ],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's state account for tracking overall platform activity",
          ],
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The user's token account that will be used for transfers"],
        },
        {
          name: 'userStateTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ['The token account owned by the user_state PDA'],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderOutcome',
          type: 'u8',
        },
        {
          name: 'price',
          type: 'u8',
        },
        {
          name: 'size',
          type: 'u32',
        },
        {
          name: 'prevNodeId',
          type: 'u16',
        },
        {
          name: 'expiredAt',
          type: {
            option: 'u32',
          },
        },
        {
          name: 'isMarketLimit',
          type: 'bool',
        },
        {
          name: 'isMerge',
          type: 'bool',
        },
      ],
    },
    {
      name: 'placeLimitOrder5000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be the owner of the token account'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'authority',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: [
            'The prediction market account where the order is being placed',
          ],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing all orders for this market'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'oracle',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's position state for tracking shares in this market",
          ],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's state account for tracking overall platform activity",
          ],
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The user's token account that will be used for transfers"],
        },
        {
          name: 'userStateTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ['The token account owned by the user_state PDA'],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderOutcome',
          type: 'u8',
        },
        {
          name: 'price',
          type: 'u8',
        },
        {
          name: 'size',
          type: 'u32',
        },
        {
          name: 'prevNodeId',
          type: 'u16',
        },
        {
          name: 'expiredAt',
          type: {
            option: 'u32',
          },
        },
        {
          name: 'isMarketLimit',
          type: 'bool',
        },
        {
          name: 'isMerge',
          type: 'bool',
        },
      ],
    },
    {
      name: 'placeLimitOrder20000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be the owner of the token account'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'authority',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: [
            'The prediction market account where the order is being placed',
          ],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing all orders for this market'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'oracle',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's position state for tracking shares in this market",
          ],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's state account for tracking overall platform activity",
          ],
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The user's token account that will be used for transfers"],
        },
        {
          name: 'userStateTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ['The token account owned by the user_state PDA'],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderOutcome',
          type: 'u8',
        },
        {
          name: 'price',
          type: 'u8',
        },
        {
          name: 'size',
          type: 'u32',
        },
        {
          name: 'prevNodeId',
          type: 'u16',
        },
        {
          name: 'expiredAt',
          type: {
            option: 'u32',
          },
        },
        {
          name: 'isMarketLimit',
          type: 'bool',
        },
        {
          name: 'isMerge',
          type: 'bool',
        },
      ],
    },
    {
      name: 'placeMarketOrder',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
        },
        {
          name: 'oracle',
          isMut: true,
          isSigner: false,
          docs: ['CHECKED: ORACLE'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userStateTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'referralState',
          isMut: true,
          isSigner: false,
          isOptional: true,
        },
        {
          name: 'feeTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderOutcome',
          type: 'u8',
        },
        {
          name: 'size',
          type: 'u32',
        },
        {
          name: 'limitIdsToFill',
          type: {
            vec: 'u16',
          },
        },
        {
          name: 'isMarketLimit',
          type: 'bool',
        },
      ],
    },
    {
      name: 'placeMarketOrder200',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
        },
        {
          name: 'oracle',
          isMut: true,
          isSigner: false,
          docs: ['CHECKED: ORACLE'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userStateTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'referralState',
          isMut: true,
          isSigner: false,
          isOptional: true,
        },
        {
          name: 'feeTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderOutcome',
          type: 'u8',
        },
        {
          name: 'size',
          type: 'u32',
        },
        {
          name: 'limitIdsToFill',
          type: {
            vec: 'u16',
          },
        },
        {
          name: 'isMarketLimit',
          type: 'bool',
        },
      ],
    },
    {
      name: 'placeMarketOrder5000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
        },
        {
          name: 'oracle',
          isMut: true,
          isSigner: false,
          docs: ['CHECKED: ORACLE'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userStateTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'referralState',
          isMut: true,
          isSigner: false,
          isOptional: true,
        },
        {
          name: 'feeTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderOutcome',
          type: 'u8',
        },
        {
          name: 'size',
          type: 'u32',
        },
        {
          name: 'limitIdsToFill',
          type: {
            vec: 'u16',
          },
        },
        {
          name: 'isMarketLimit',
          type: 'bool',
        },
      ],
    },
    {
      name: 'placeMarketOrder20000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
        },
        {
          name: 'oracle',
          isMut: true,
          isSigner: false,
          docs: ['CHECKED: ORACLE'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'userStateTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'referralState',
          isMut: true,
          isSigner: false,
          isOptional: true,
        },
        {
          name: 'feeTokenAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderOutcome',
          type: 'u8',
        },
        {
          name: 'size',
          type: 'u32',
        },
        {
          name: 'limitIdsToFill',
          type: {
            vec: 'u16',
          },
        },
        {
          name: 'isMarketLimit',
          type: 'bool',
        },
      ],
    },
    {
      name: 'settleOrders',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer initiating the settlement'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing all orders for this market'],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account for the orders being settled'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ['The vault that holds collateral for the market'],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'vault',
          isMut: true,
          isSigner: false,
          docs: [
            'The fee vault account that collects trading fees',
            'CHECKED: VAULT',
          ],
        },
        {
          name: 'feeTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ['The token account for collecting fees'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program for SOL transfers and account creation'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'idsToSettle',
          type: {
            vec: 'u16',
          },
        },
        {
          name: 'accountsScheme',
          type: {
            vec: {
              vec: 'u16',
            },
          },
        },
      ],
    },
    {
      name: 'settleOrders200',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer initiating the settlement'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing all orders for this market'],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account for the orders being settled'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ['The vault that holds collateral for the market'],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'vault',
          isMut: true,
          isSigner: false,
          docs: [
            'The fee vault account that collects trading fees',
            'CHECKED: VAULT',
          ],
        },
        {
          name: 'feeTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ['The token account for collecting fees'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program for SOL transfers and account creation'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'idsToSettle',
          type: {
            vec: 'u16',
          },
        },
        {
          name: 'accountsScheme',
          type: {
            vec: {
              vec: 'u16',
            },
          },
        },
      ],
    },
    {
      name: 'settleOrders5000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer initiating the settlement'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing all orders for this market'],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account for the orders being settled'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ['The vault that holds collateral for the market'],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'vault',
          isMut: true,
          isSigner: false,
          docs: [
            'The fee vault account that collects trading fees',
            'CHECKED: VAULT',
          ],
        },
        {
          name: 'feeTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ['The token account for collecting fees'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program for SOL transfers and account creation'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'idsToSettle',
          type: {
            vec: 'u16',
          },
        },
        {
          name: 'accountsScheme',
          type: {
            vec: {
              vec: 'u16',
            },
          },
        },
      ],
    },
    {
      name: 'settleOrders20000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer initiating the settlement'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing all orders for this market'],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account for the orders being settled'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ['The vault that holds collateral for the market'],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'vault',
          isMut: true,
          isSigner: false,
          docs: [
            'The fee vault account that collects trading fees',
            'CHECKED: VAULT',
          ],
        },
        {
          name: 'feeTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ['The token account for collecting fees'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program for SOL transfers and account creation'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'idsToSettle',
          type: {
            vec: 'u16',
          },
        },
        {
          name: 'accountsScheme',
          type: {
            vec: {
              vec: 'u16',
            },
          },
        },
      ],
    },
    {
      name: 'cancelLimitOrder',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be the owner of the order'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing the order to be canceled'],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account containing the order'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ["The token account holding the market's collateral"],
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The user's token account to receive refunded collateral"],
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
          docs: ["The user's position account for this market"],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: ["The user's global state account"],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderId',
          type: 'u16',
        },
      ],
    },
    {
      name: 'cancelLimitOrder200',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be the owner of the order'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing the order to be canceled'],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account containing the order'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ["The token account holding the market's collateral"],
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The user's token account to receive refunded collateral"],
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
          docs: ["The user's position account for this market"],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: ["The user's global state account"],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderId',
          type: 'u16',
        },
      ],
    },
    {
      name: 'cancelLimitOrder5000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be the owner of the order'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing the order to be canceled'],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account containing the order'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ["The token account holding the market's collateral"],
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The user's token account to receive refunded collateral"],
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
          docs: ["The user's position account for this market"],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: ["The user's global state account"],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderId',
          type: 'u16',
        },
      ],
    },
    {
      name: 'cancelLimitOrder20000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be the owner of the order'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'orderbook',
          isMut: true,
          isSigner: false,
          docs: ['The orderbook containing the order to be canceled'],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account containing the order'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ["The token account holding the market's collateral"],
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The user's token account to receive refunded collateral"],
        },
        {
          name: 'userPositionState',
          isMut: true,
          isSigner: false,
          docs: ["The user's position account for this market"],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: ["The user's global state account"],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'orderType',
          type: 'u8',
        },
        {
          name: 'orderId',
          type: 'u16',
        },
      ],
    },
    {
      name: 'createReferral',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer creating the referral code'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: ["The user's state account, initialized if it doesn't exist"],
        },
        {
          name: 'referrerState',
          isMut: true,
          isSigner: false,
          docs: ['The new referral state account to be created'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'code',
          type: 'string',
        },
      ],
    },
    {
      name: 'claimFee',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The authority that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: [
            "Global state account storing the program's configuration and fee tracking",
          ],
        },
        {
          name: 'signerTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The authority's token account to receive the claimed fees"],
        },
        {
          name: 'vault',
          isMut: true,
          isSigner: false,
          docs: ['Program vault PDA that signs for token transfers'],
        },
        {
          name: 'feeVault',
          isMut: true,
          isSigner: false,
          docs: [
            'The fee vault token account that holds accumulated protocol fees',
          ],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [],
    },
    {
      name: 'changeConfig',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The current authority that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'args',
          type: {
            defined: 'ChangeConfigArgs',
          },
        },
      ],
    },
    {
      name: 'settleResult',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The oracle that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'predictionMarket',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account to be settled'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'result',
          type: 'u8',
        },
        {
          name: 'settlementTimestamp',
          type: 'u64',
        },
      ],
    },
    {
      name: 'claimReferralFee',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be the owner of the UserState'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'signerTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The user's token account that will receive the claimed fees"],
        },
        {
          name: 'vault',
          isMut: true,
          isSigner: false,
          docs: ['Program vault PDA that signs for token transfers'],
        },
        {
          name: 'feeVault',
          isMut: true,
          isSigner: false,
          docs: ['The fee vault token account that holds collected fees'],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's state account that tracks referral fees earned and claimed",
          ],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [],
    },
    {
      name: 'changeMarketStatus',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be either the oracle or the authority'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'predictionMarket',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account to be modified'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'status',
          type: 'u8',
        },
      ],
    },
    {
      name: 'settleWinningFunds',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The oracle that must sign the transaction'],
        },
        {
          name: 'authorityTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ["The oracle's token account to receive settlement fees"],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account whose winners will be paid'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ["The token account holding the market's collateral"],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'vault',
          isMut: true,
          isSigner: false,
          docs: [
            'Program vault PDA that signs for token transfers',
            'CHECKED: VAULT',
          ],
        },
        {
          name: 'feeTokenAccount',
          isMut: true,
          isSigner: false,
          docs: ['The fee vault token account that holds collected fees'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
      ],
    },
    {
      name: 'claimLimitFunds',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be the owner of the UserState'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'userState',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's state account that holds ownership of the token account",
          ],
        },
        {
          name: 'userStateTokenAccount',
          isMut: true,
          isSigner: false,
          docs: [
            'The token account owned by the user_state PDA which holds the funds',
          ],
        },
        {
          name: 'userTokenAccount',
          isMut: true,
          isSigner: false,
          docs: [
            "The user's personal token account that will receive the funds",
          ],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [],
    },
    {
      name: 'editMarket',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The signer must be either the oracle or the authority'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'adminState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionMarket',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account to be modified'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
        {
          name: 'args',
          type: {
            defined: 'EditMarketArgs',
          },
        },
      ],
    },
    {
      name: 'changeAuthority',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The current authority that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'authority',
          type: 'publicKey',
        },
      ],
    },
    {
      name: 'collectRemainingFunds',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The oracle that must sign the transaction'],
        },
        {
          name: 'authority',
          isMut: true,
          isSigner: false,
          docs: ['The authority account that will receive the funds'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'predictionMarket',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account whose funds will be collected'],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ["The token account holding the market's collateral"],
        },
        {
          name: 'authorityTokenAccount',
          isMut: true,
          isSigner: false,
          docs: [
            "The authority's token account to receive the recovered funds",
          ],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
      ],
    },
    {
      name: 'refund',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The oracle that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: ['The prediction market account whose funds will be refunded'],
        },
        {
          name: 'predictionVault',
          isMut: true,
          isSigner: false,
          docs: ["The token account holding the market's collateral"],
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
          docs: ['The mint of the token being transferred'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Token program interface for token transfers'],
        },
        {
          name: 'associatedTokenProgram',
          isMut: false,
          isSigner: false,
          docs: ['Associated token program for token account validation'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
      ],
    },
    {
      name: 'migrateOrderbook5000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The admin that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'adminState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: [
            'The prediction market account to update with the new orderbook',
          ],
        },
        {
          name: 'sourceOrderbook',
          isMut: true,
          isSigner: false,
          docs: ['The source orderbook account (1000 order capacity)'],
        },
        {
          name: 'targetOrderbook',
          isMut: true,
          isSigner: false,
          docs: [
            'The target orderbook account (2000 order capacity)',
            'This account should be initialized but empty',
          ],
        },
        {
          name: 'authority',
          isMut: true,
          isSigner: false,
          docs: [
            'The authority that will receive the lamports from the closed source orderbook',
          ],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
      ],
    },
    {
      name: 'migrateOrderbook20000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The admin that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'adminState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: [
            'The prediction market account to update with the new orderbook',
          ],
        },
        {
          name: 'sourceOrderbook',
          isMut: true,
          isSigner: false,
          isOptional: true,
          docs: ['The source orderbook account (1000 order capacity)'],
        },
        {
          name: 'sourceOrderbook5000',
          isMut: true,
          isSigner: false,
          isOptional: true,
          docs: ['The source orderbook account (3000 order capacity)'],
        },
        {
          name: 'targetOrderbook',
          isMut: true,
          isSigner: false,
          docs: ['The target orderbook account (8000 order capacity)'],
        },
        {
          name: 'authority',
          isMut: true,
          isSigner: false,
          docs: [
            'The authority that will receive the lamports from the closed source orderbook',
          ],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
      ],
    },
    {
      name: 'migrateOrderbook1000',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The admin that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'adminState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: [
            'The prediction market account to update with the new orderbook',
          ],
        },
        {
          name: 'sourceOrderbook',
          isMut: true,
          isSigner: false,
          docs: ['The source orderbook account (500 orders per side)'],
        },
        {
          name: 'targetOrderbook',
          isMut: true,
          isSigner: false,
          docs: [
            'The target orderbook account (100 orders per side)',
            'This account should be initialized but empty',
          ],
        },
        {
          name: 'authority',
          isMut: true,
          isSigner: false,
          docs: [
            'The authority that will receive the lamports from the closed source orderbook',
          ],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
      ],
    },
    {
      name: 'migrateOrderbook200',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The admin that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'adminState',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'predictionState',
          isMut: true,
          isSigner: false,
          docs: [
            'The prediction market account to update with the new orderbook',
          ],
        },
        {
          name: 'sourceOrderbook',
          isMut: true,
          isSigner: false,
          docs: ['The source orderbook account (1000 order capacity)'],
        },
        {
          name: 'targetOrderbook',
          isMut: true,
          isSigner: false,
          docs: [
            'The target orderbook account (2000 order capacity)',
            'This account should be initialized but empty',
          ],
        },
        {
          name: 'authority',
          isMut: true,
          isSigner: false,
          docs: [
            'The authority that will receive the lamports from the closed source orderbook',
          ],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'marketId',
          type: 'u64',
        },
      ],
    },
    {
      name: 'changeAdmin',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The current authority that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'adminState',
          isMut: true,
          isSigner: false,
          docs: ['The admin state account'],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'index',
          type: 'u8',
        },
        {
          name: 'admin',
          type: 'publicKey',
        },
        {
          name: 'isAdmin',
          type: 'bool',
        },
      ],
    },
    {
      name: 'changeWhitelist',
      accounts: [
        {
          name: 'signer',
          isMut: true,
          isSigner: true,
          docs: ['The current authority that must sign the transaction'],
        },
        {
          name: 'globalState',
          isMut: true,
          isSigner: false,
          docs: ["Global state account storing the program's configuration"],
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
          docs: ['System program'],
        },
      ],
      args: [
        {
          name: 'isWhitelisted',
          type: 'u32',
        },
      ],
    },
  ],
  accounts: [
    {
      name: 'adminState',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'admins',
            type: {
              array: ['publicKey', 10],
            },
          },
        ],
      },
    },
    {
      name: 'globalState',
      docs: [
        'GlobalState manages program-wide configuration parameters',
        '',
        'This is the central account that stores program settings, fee structures,',
        'and tracks global counters. There is only one instance of this account',
        'per program deployment.',
        '',
        '# Security',
        '- Only the authority can update configuration parameters',
        '- Maintains counters for unique ID generation',
        '- Stores critical fee settings that impact user economics',
      ],
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'authority',
            docs: ['The authority who can update program parameters'],
            type: 'publicKey',
          },
          {
            name: 'oracle',
            docs: ['Oracle address that provides market resolution'],
            type: 'publicKey',
          },
          {
            name: 'feeVault',
            type: 'publicKey',
          },
          {
            name: 'referralFeeCap',
            docs: ['Maximum referral fee allowed (lamports)'],
            type: 'u64',
          },
          {
            name: 'tradeFeePercent',
            docs: ['Fee percentage for trades (basis points)'],
            type: 'u16',
          },
          {
            name: 'settleFeePercent',
            docs: ['Fee percentage for settlements (basis points)'],
            type: 'u16',
          },
          {
            name: 'referralFeePercent',
            docs: ['Fee percentage for referrals (basis points)'],
            type: 'u16',
          },
          {
            name: 'referralFeeDiscount',
            docs: ['Discount for referral fees (basis points)'],
            type: 'u16',
          },
          {
            name: 'claimableAdminFee',
            docs: ['Claimable admin fee (lamports)'],
            type: 'u64',
          },
          {
            name: 'limitOrderFeeSol',
            docs: ['Limit order fee in SOL (lamports)'],
            type: 'u32',
          },
          {
            name: 'settlementFeeSol',
            docs: ['Settlement fee in SOL (lamports)'],
            type: 'u32',
          },
          {
            name: 'predictionId',
            docs: ['ID that will be created next'],
            type: 'u64',
          },
          {
            name: 'collateralMint',
            docs: ['Collateral token mint'],
            type: 'publicKey',
          },
          {
            name: 'liquidityIncentiveMaxSpread',
            docs: ['Liquidity incentive max spread (bps), 1 cent - 1'],
            type: 'u8',
          },
          {
            name: 'liquidityIncentiveDiscountPerSpread',
            docs: [
              'Liquidity incentive discount percent, 100 = 1%',
              'Example: default fee = 100 (1%), liquidity incentive discount = 10 (0.1%), max_spread = 1, spread = 1',
              'effective fee = 90 (0.9%)',
              'Example: default fee = 100 (1%), liquidity incentive discount = 10 (0.1%), max_spread = 3, spread = 1,',
              'effective fee = 70 (0.7%)',
              'Example: default fee = 100 (1%), liquidity incentive discount = 10 (0.1%), max_spread = 3, spread = 4',
              'effective fee = 100 (1%)',
              'Example: default fee = 100 (1%), liquidity incentive discount = 10 (0.1%), max_spread = 3, spread = 3',
              'effective fee = 90 (0.9%)',
            ],
            type: 'u8',
          },
          {
            name: 'expirationThreshold',
            docs: ['Expiration threshold for orders (seconds)'],
            type: 'u16',
          },
          {
            name: 'nextOrderId',
            docs: ['Next order ID'],
            type: 'u32',
          },
        ],
      },
    },
    {
      name: 'orderBook20000',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'bids',
            type: {
              array: [
                {
                  defined: 'Order',
                },
                10000,
              ],
            },
          },
          {
            name: 'asks',
            type: {
              array: [
                {
                  defined: 'Order',
                },
                10000,
              ],
            },
          },
          {
            name: 'bidHead',
            type: 'u16',
          },
          {
            name: 'askHead',
            type: 'u16',
          },
          {
            name: 'bidFreeListHead',
            type: 'u16',
          },
          {
            name: 'askFreeListHead',
            type: 'u16',
          },
          {
            name: 'globalState',
            type: 'publicKey',
          },
        ],
      },
    },
    {
      name: 'orderBook200',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'bids',
            type: {
              array: [
                {
                  defined: 'Order',
                },
                100,
              ],
            },
          },
          {
            name: 'asks',
            type: {
              array: [
                {
                  defined: 'Order',
                },
                100,
              ],
            },
          },
          {
            name: 'bidHead',
            type: 'u16',
          },
          {
            name: 'askHead',
            type: 'u16',
          },
          {
            name: 'bidFreeListHead',
            type: 'u16',
          },
          {
            name: 'askFreeListHead',
            type: 'u16',
          },
          {
            name: 'globalState',
            type: 'publicKey',
          },
        ],
      },
    },
    {
      name: 'orderBook5000',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'bids',
            type: {
              array: [
                {
                  defined: 'Order',
                },
                2500,
              ],
            },
          },
          {
            name: 'asks',
            type: {
              array: [
                {
                  defined: 'Order',
                },
                2500,
              ],
            },
          },
          {
            name: 'bidHead',
            type: 'u16',
          },
          {
            name: 'askHead',
            type: 'u16',
          },
          {
            name: 'bidFreeListHead',
            type: 'u16',
          },
          {
            name: 'askFreeListHead',
            type: 'u16',
          },
          {
            name: 'globalState',
            type: 'publicKey',
          },
        ],
      },
    },
    {
      name: 'orderBook',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'bids',
            type: {
              array: [
                {
                  defined: 'Order',
                },
                500,
              ],
            },
          },
          {
            name: 'asks',
            type: {
              array: [
                {
                  defined: 'Order',
                },
                500,
              ],
            },
          },
          {
            name: 'bidHead',
            type: 'u16',
          },
          {
            name: 'askHead',
            type: 'u16',
          },
          {
            name: 'bidFreeListHead',
            type: 'u16',
          },
          {
            name: 'askFreeListHead',
            type: 'u16',
          },
          {
            name: 'globalState',
            type: 'publicKey',
          },
        ],
      },
    },
    {
      name: 'predictionMarketState',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'token',
            type: 'publicKey',
          },
          {
            name: 'orderbook',
            type: 'publicKey',
          },
          {
            name: 'orderbookSize',
            type: 'u16',
          },
          {
            name: 'predictionVault',
            type: 'publicKey',
          },
          {
            name: 'startTime',
            type: 'u64',
          },
          {
            name: 'endTime',
            type: 'u64',
          },
          {
            name: 'targetPrice',
            type: 'u64',
          },
          {
            name: 'predictionType',
            type: 'u16',
          },
          {
            name: 'targetPriceDirection',
            type: 'u8',
          },
          {
            name: 'result',
            type: 'u8',
          },
          {
            name: 'minSize',
            type: 'u64',
          },
          {
            name: 'status',
            type: 'u8',
          },
          {
            name: 'settlementTimestamp',
            type: 'u64',
          },
          {
            name: 'tradeFeePercent',
            type: 'u16',
          },
          {
            name: 'settleFeePercent',
            type: 'u16',
          },
        ],
      },
    },
    {
      name: 'referralState',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'user',
            type: 'publicKey',
          },
          {
            name: 'code',
            type: 'string',
          },
        ],
      },
    },
    {
      name: 'userPositionState',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'user',
            type: 'publicKey',
          },
          {
            name: 'marketId',
            type: 'u64',
          },
          {
            name: 'yesShares',
            type: 'u64',
          },
          {
            name: 'noShares',
            type: 'u64',
          },
          {
            name: 'feePayed',
            type: 'bool',
          },
          {
            name: 'totalSpent',
            type: 'u64',
          },
        ],
      },
    },
    {
      name: 'userState',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'user',
            type: 'publicKey',
          },
          {
            name: 'referrer',
            type: {
              option: 'publicKey',
            },
          },
          {
            name: 'code',
            type: {
              option: 'string',
            },
          },
          {
            name: 'totalReferrals',
            type: 'u32',
          },
          {
            name: 'isWhitelisted',
            type: 'u32',
          },
          {
            name: 'totalFeeEarned',
            type: 'u64',
          },
          {
            name: 'totalFeeClaimed',
            type: 'u64',
          },
        ],
      },
    },
  ],
  types: [
    {
      name: 'ComboBetCondition',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'token',
            type: {
              option: 'publicKey',
            },
          },
          {
            name: 'wallet',
            type: {
              option: 'publicKey',
            },
          },
          {
            name: 'predictionType',
            type: 'u16',
          },
          {
            name: 'targetPrice',
            type: 'u64',
          },
          {
            name: 'targetPriceDirection',
            type: 'u8',
          },
        ],
      },
    },
    {
      name: 'InitArgs',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'oracle',
            type: 'publicKey',
          },
          {
            name: 'tradeFeePercent',
            type: 'u16',
          },
          {
            name: 'settleFeePercent',
            type: 'u16',
          },
          {
            name: 'referralFeePercent',
            type: 'u16',
          },
          {
            name: 'referralFeeCap',
            type: 'u64',
          },
          {
            name: 'collateralMint',
            type: 'publicKey',
          },
        ],
      },
    },
    {
      name: 'CreatePredictionArgs',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'token',
            type: {
              option: 'publicKey',
            },
          },
          {
            name: 'wallet',
            type: {
              option: 'publicKey',
            },
          },
          {
            name: 'startTime',
            type: 'u64',
          },
          {
            name: 'endTime',
            type: 'u64',
          },
          {
            name: 'targetPrice',
            type: 'u64',
          },
          {
            name: 'targetPriceDirection',
            type: 'u8',
          },
          {
            name: 'minSize',
            type: 'u64',
          },
          {
            name: 'predictionType',
            type: 'u16',
          },
          {
            name: 'comboConditions',
            type: {
              vec: {
                defined: 'ComboBetCondition',
              },
            },
          },
        ],
      },
    },
    {
      name: 'ChangeConfigArgs',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'oracle',
            type: 'publicKey',
          },
          {
            name: 'tradeFeePercent',
            type: 'u16',
          },
          {
            name: 'settleFeePercent',
            type: 'u16',
          },
          {
            name: 'referralFeePercent',
            type: 'u16',
          },
          {
            name: 'referralFeeDiscount',
            type: 'u16',
          },
          {
            name: 'referralFeeCap',
            type: 'u64',
          },
          {
            name: 'settlementFeeSol',
            type: 'u32',
          },
          {
            name: 'limitOrderFeeSol',
            type: 'u32',
          },
          {
            name: 'expirationThreshold',
            type: 'u16',
          },
          {
            name: 'liquidityIncentiveMaxSpread',
            type: 'u8',
          },
          {
            name: 'liquidityIncentiveDiscountPerSpread',
            type: 'u8',
          },
        ],
      },
    },
    {
      name: 'EditMarketArgs',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'token',
            type: 'publicKey',
          },
          {
            name: 'startTime',
            type: 'u64',
          },
          {
            name: 'endTime',
            type: 'u64',
          },
          {
            name: 'targetPrice',
            type: 'u64',
          },
          {
            name: 'targetPriceDirection',
            type: 'u8',
          },
          {
            name: 'minSize',
            type: 'u64',
          },
          {
            name: 'tradeFeePercent',
            type: 'u16',
          },
          {
            name: 'settleFeePercent',
            type: 'u16',
          },
        ],
      },
    },
    {
      name: 'Order',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'user',
            type: 'publicKey',
          },
          {
            name: 'id',
            type: 'u32',
          },
          {
            name: 'size',
            type: 'u32',
          },
          {
            name: 'next',
            type: 'u16',
          },
          {
            name: 'prev',
            type: 'u16',
          },
          {
            name: 'price',
            type: 'u8',
          },
          {
            name: 'isFilled',
            type: 'u8',
          },
          {
            name: 'outcome',
            type: 'u8',
          },
          {
            name: 'spread',
            type: 'u8',
          },
          {
            name: 'expiryTimestamp',
            type: 'u32',
          },
          {
            name: 'feePayed',
            type: 'u32',
          },
        ],
      },
    },
  ],
  events: [
    {
      name: 'PredictionMarketCreated',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'predictionId',
          type: 'u64',
          index: false,
        },
        {
          name: 'startTime',
          type: 'u64',
          index: false,
        },
        {
          name: 'endTime',
          type: 'u64',
          index: false,
        },
        {
          name: 'token',
          type: {
            option: 'publicKey',
          },
          index: false,
        },
        {
          name: 'wallet',
          type: {
            option: 'publicKey',
          },
          index: false,
        },
        {
          name: 'predictionType',
          type: 'u16',
          index: false,
        },
        {
          name: 'targetPrice',
          type: 'u64',
          index: false,
        },
        {
          name: 'targetPriceDirection',
          type: 'u8',
          index: false,
        },
        {
          name: 'comboConditions',
          type: {
            vec: {
              defined: 'ComboBetCondition',
            },
          },
          index: false,
        },
      ],
    },
    {
      name: 'OrderPlaced',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'marketId',
          type: 'u64',
          index: false,
        },
        {
          name: 'orderId',
          type: 'u32',
          index: false,
        },
        {
          name: 'user',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'orderSide',
          type: 'u8',
          index: false,
        },
        {
          name: 'orderOutcome',
          type: 'u8',
          index: false,
        },
        {
          name: 'price',
          type: 'u8',
          index: false,
        },
        {
          name: 'size',
          type: 'u32',
          index: false,
        },
        {
          name: 'timestamp',
          type: 'u64',
          index: false,
        },
        {
          name: 'expiryTimestamp',
          type: 'u64',
          index: false,
        },
      ],
    },
    {
      name: 'OrderFilled',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'marketId',
          type: 'u64',
          index: false,
        },
        {
          name: 'orderId',
          type: 'u32',
          index: false,
        },
        {
          name: 'user',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'orderSide',
          type: 'u8',
          index: false,
        },
        {
          name: 'orderType',
          type: 'u8',
          index: false,
        },
        {
          name: 'orderOutcome',
          type: 'u8',
          index: false,
        },
        {
          name: 'avrgPrice',
          type: 'u8',
          index: false,
        },
        {
          name: 'size',
          type: 'u32',
          index: false,
        },
        {
          name: 'timestamp',
          type: 'u64',
          index: false,
        },
        {
          name: 'adminFee',
          type: 'u64',
          index: false,
        },
        {
          name: 'referralFee',
          type: 'u64',
          index: false,
        },
      ],
    },
    {
      name: 'OrderCancelled',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'marketId',
          type: 'u64',
          index: false,
        },
        {
          name: 'orderId',
          type: 'u32',
          index: false,
        },
        {
          name: 'user',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'timestamp',
          type: 'u64',
          index: false,
        },
      ],
    },
    {
      name: 'ReferralCreated',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'user',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'code',
          type: 'string',
          index: false,
        },
      ],
    },
    {
      name: 'ReferralSubmitted',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'user',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'code',
          type: 'string',
          index: false,
        },
      ],
    },
    {
      name: 'ReferralFeeClaimed',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'user',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'amount',
          type: 'u64',
          index: false,
        },
        {
          name: 'referralCode',
          type: 'string',
          index: false,
        },
      ],
    },
    {
      name: 'PredictionSettled',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'marketId',
          type: 'u64',
          index: false,
        },
        {
          name: 'result',
          type: 'u8',
          index: false,
        },
        {
          name: 'settlementTimestamp',
          type: 'u64',
          index: false,
        },
      ],
    },
    {
      name: 'WinningFundsSettled',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'marketId',
          type: 'u64',
          index: false,
        },
        {
          name: 'user',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'winShares',
          type: 'u32',
          index: false,
        },
        {
          name: 'loseShares',
          type: 'u32',
          index: false,
        },
        {
          name: 'payout',
          type: 'u64',
          index: false,
        },
        {
          name: 'referralFee',
          type: 'u64',
          index: false,
        },
        {
          name: 'adminFee',
          type: 'u64',
          index: false,
        },
      ],
    },
    {
      name: 'RefundedFunds',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'marketId',
          type: 'u64',
          index: false,
        },
        {
          name: 'user',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'refundAmount',
          type: 'u64',
          index: false,
        },
      ],
    },
    {
      name: 'PredictionMarketStatusChanged',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'marketId',
          type: 'u64',
          index: false,
        },
        {
          name: 'status',
          type: 'u8',
          index: false,
        },
      ],
    },
    {
      name: 'PredictionMarketEdited',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'marketId',
          type: 'u64',
          index: false,
        },
        {
          name: 'token',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'startTime',
          type: 'u64',
          index: false,
        },
        {
          name: 'endTime',
          type: 'u64',
          index: false,
        },
        {
          name: 'targetPrice',
          type: 'u64',
          index: false,
        },
        {
          name: 'targetPriceDirection',
          type: 'u8',
          index: false,
        },
        {
          name: 'minSize',
          type: 'u64',
          index: false,
        },
        {
          name: 'tradeFeePercent',
          type: 'u16',
          index: false,
        },
        {
          name: 'settleFeePercent',
          type: 'u16',
          index: false,
        },
      ],
    },
    {
      name: 'TokensClaimed',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'user',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'amount',
          type: 'u64',
          index: false,
        },
        {
          name: 'timestamp',
          type: 'u64',
          index: false,
        },
      ],
    },
    {
      name: 'OrderbookClosed',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'marketId',
          type: 'u64',
          index: false,
        },
        {
          name: 'timestamp',
          type: 'u64',
          index: false,
        },
      ],
    },
    {
      name: 'RemainingFundsCollected',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'marketId',
          type: 'u64',
          index: false,
        },
        {
          name: 'timestamp',
          type: 'u64',
          index: false,
        },
      ],
    },
    {
      name: 'AdminChanged',
      fields: [
        {
          name: 'globalState',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'admin',
          type: 'publicKey',
          index: false,
        },
        {
          name: 'isAdmin',
          type: 'bool',
          index: false,
        },
      ],
    },
  ],
  errors: [
    {
      code: 6000,
      name: 'NotAuthority',
      msg: 'Not an authority!',
    },
    {
      code: 6001,
      name: 'InvalidProposalType',
      msg: 'Invalid proposal type!',
    },
    {
      code: 6002,
      name: 'InvalidTargetPriceDirection',
      msg: 'Invalid target price direction!',
    },
    {
      code: 6003,
      name: 'InvalidResult',
      msg: 'Invalid result!',
    },
    {
      code: 6004,
      name: 'InvalidStartTime',
      msg: 'Invalid start time!',
    },
    {
      code: 6005,
      name: 'InvalidCollateralMint',
      msg: 'Invalid collateral mint!',
    },
    {
      code: 6006,
      name: 'InvalidInput',
      msg: 'Invalid input parameters',
    },
    {
      code: 6007,
      name: 'OrderNotActive',
      msg: 'Order is not active',
    },
    {
      code: 6008,
      name: 'OrderNotFilled',
      msg: 'Order is not filled',
    },
    {
      code: 6009,
      name: 'InvalidFillSize',
      msg: 'Invalid fill size',
    },
    {
      code: 6010,
      name: 'SizeMismatch',
      msg: 'Size mismatch between bid and ask orders',
    },
    {
      code: 6011,
      name: 'InvalidOrderPosition',
      msg: 'Order position is invalid',
    },
    {
      code: 6012,
      name: 'OwnerMismatch',
      msg: 'Owner mismatch',
    },
    {
      code: 6013,
      name: 'InvalidSide',
      msg: 'Invalid side',
    },
    {
      code: 6014,
      name: 'InvalidPrice',
      msg: 'Invalid price',
    },
    {
      code: 6015,
      name: 'InvalidSize',
      msg: 'Invalid size',
    },
    {
      code: 6016,
      name: 'InsufficientShares',
      msg: 'Insufficient shares',
    },
    {
      code: 6017,
      name: 'InvalidLimitOrder',
      msg: 'Please use market order',
    },
    {
      code: 6018,
      name: 'NoOrdersToFill',
      msg: 'No orders to fill',
    },
    {
      code: 6019,
      name: 'InvalidOrderSequence',
      msg: 'Invalid order sequence',
    },
    {
      code: 6020,
      name: 'InvalidOrderId',
      msg: 'Invalid order ID',
    },
    {
      code: 6021,
      name: 'OrderAlreadyFilled',
      msg: 'Order already filled',
    },
    {
      code: 6022,
      name: 'InsufficientLiquidity',
      msg: 'Insufficient liquidity',
    },
    {
      code: 6023,
      name: 'OrderCannotBeSettled',
      msg: 'Order cannot be settled',
    },
    {
      code: 6024,
      name: 'MissingUserAccounts',
      msg: 'Missing user accounts',
    },
    {
      code: 6025,
      name: 'InvalidReferrer',
      msg: 'Invalid referrer',
    },
    {
      code: 6026,
      name: 'PredictionNotActive',
      msg: 'Prediction not active',
    },
    {
      code: 6027,
      name: 'CantChangeReferrer',
      msg: "You can't change your referrer",
    },
    {
      code: 6028,
      name: 'CantReferSelf',
      msg: "Can't refer yourself",
    },
    {
      code: 6029,
      name: 'ResultAlreadySettled',
      msg: 'Result already settled',
    },
    {
      code: 6030,
      name: 'NoClaimableFee',
      msg: 'No claimable fee',
    },
    {
      code: 6031,
      name: 'InvalidExpiration',
      msg: 'Invalid expiration',
    },
    {
      code: 6032,
      name: 'OrderExpired',
      msg: 'Order expired',
    },
    {
      code: 6033,
      name: 'MarketNotResolved',
      msg: 'Market not resolved',
    },
    {
      code: 6034,
      name: 'InvalidCode',
      msg: 'Invalid code',
    },
    {
      code: 6035,
      name: 'EmptyReferralCode',
      msg: 'Empty referral code',
    },
    {
      code: 6036,
      name: 'ReferralCodeTooLong',
      msg: 'Referral code too long',
    },
    {
      code: 6037,
      name: 'MarketLimitConstraintViolated',
      msg: 'Market limit constraint violated',
    },
    {
      code: 6038,
      name: 'MarketLimitPriceConflict',
      msg: 'Market limit price conflict',
    },
    {
      code: 6039,
      name: 'MarketNotClosed',
      msg: 'Market is not closed',
    },
    {
      code: 6040,
      name: 'MarketLimitOrderNotAllowed',
      msg: 'Market limit order is not allowed',
    },
    {
      code: 6041,
      name: 'InvalidOrderbookSize',
      msg: 'Invalid orderbook size',
    },
    {
      code: 6042,
      name: 'InvalidOrderbook',
      msg: 'Invalid orderbook',
    },
    {
      code: 6043,
      name: 'NotAdmin',
      msg: 'Not an admin',
    },
    {
      code: 6044,
      name: 'NoSpaceForAdmin',
      msg: 'No space for admin',
    },
  ],
};
